export default "assets/us-2729770f.svg";